import { Modal } from '../../../school_panel/components/ui';
import type { StaffSchoolTask } from '../../../school_panel/api/types';
import { dueLabel } from '../taskStatus';
import TaskTrackerBody from './TaskTrackerBody';

export default function TaskTrackerDrawer({ task, onClose }: { task: StaffSchoolTask | null; onClose: () => void }) {
  return (
    <Modal isOpen={task != null} onClose={onClose} side="right" size="lg" title={task?.title}>
      {task && (
        <>
          <p className="mb-3 text-xs text-muted">
            {task.audience_label}{task.due_at ? ` · Due ${dueLabel(task.due_at)}` : ''}
          </p>
          <TaskTrackerBody taskId={task.id} />
        </>
      )}
    </Modal>
  );
}
